/**
   * From https://stackoverflow.com/a/44779316
   *
   * @param {Function} fn Callback function
   * @param {Boolean|undefined} [throttle] Optionally throttle callback
   * @return {Function} Bound function
   *
   * @example
   * //generate rAFed function
   * jQuery.fn.addClassRaf = bindRaf(jQuery.fn.addClass);
   *
   * //use rAFed function
   * $('div').addClassRaf('is-stuck');
   */

export function animateDebounce(fn: Function) {
    let isRunning = false;
    return () => {

        if (isRunning) {
            console.log("doing nothing")
            return;
        }
        isRunning = true;
        requestAnimationFrame(() => {
            isRunning = false;
            fn();
        });
    };
}